import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import CustomerDashboard from './CustomerDashboard';
import CompanyDashboard from './CompanyDashboard';
import PartnerDashboard from './PartnerDashboard';
import PartnerOnboarding from '../../components/PartnerOnboarding';
import ProtectedRoute from '../../components/ProtectedRoute';
import { getUserType } from '../../services/api';

const Panel = () => {
  // Function to redirect to the appropriate dashboard based on user type
  const getUserDashboard = () => {
    const userType = getUserType();
    console.log('Current user type detected:', userType);
    
    switch (userType) {
      case 'customer':
        console.log('Redirecting to customer dashboard');
        return <Navigate to="/panel/customer-dashboard" replace />;
      case 'company':
        console.log('Redirecting to company dashboard');
        return <Navigate to="/panel/company-dashboard" replace />;
      case 'partner':
        console.log('Redirecting to partner dashboard');
        return <Navigate to="/panel/partner-dashboard" replace />;
      default:
        // Default to the original dashboard (for backward compatibility)
        console.log('Redirecting to default dashboard');
        return <Navigate to="/panel/dashboard" replace />;
    }
  };

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/customer-dashboard" 
        element={
          <ProtectedRoute>
            <CustomerDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/company-dashboard" 
        element={
          <ProtectedRoute>
            <CompanyDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/partner-dashboard" 
        element={
          <ProtectedRoute>
            <PartnerDashboard />
          </ProtectedRoute>
        } 
      />
      <Route path="/partner-registration" element={<PartnerOnboarding />} />
      <Route path="/user" element={<ProtectedRoute>{getUserDashboard()}</ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/panel" replace />} />
    </Routes>
  );
};

export default Panel; 